module.exports = __webpack_public_path__ + "img/tok1.72af740c.png";